/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_jw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`They are standard time claims in seconds since the Unix epoch: iat (issued at), nbf (not before), and exp (expires). This tool converts them to UTC dates for you.`)
};

const es_jw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son reclamaciones de tiempo estándar en segundos desde la época Unix: iat (emitido en), nbf (no antes) y exp (expira). Esta herramienta los convierte a fechas UTC para ti.`)
};

const de_jw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das sind Standard-Zeit-Claims in Sekunden seit der Unix epoch: iat (issued at), nbf (not before) und exp (expires). Dieses Tool wandelt sie für Sie in UTC-Daten um.`)
};

const nl_jw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit zijn standaard tijdclaims in seconden sinds de Unix epoch: iat (uitgegeven op), nbf (niet eerder dan) en exp (verloopt). Dit hulpmiddel converteert ze voor u naar UTC-datums.`)
};

const fr_jw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce sont des revendications de temps standard en secondes depuis l'époque Unix : iat (émis à), nbf (pas avant) et exp (expire). Cet outil les convertit en dates UTC pour vous.`)
};

const it_jw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sono rivendicazioni di tempo standard in secondi dall'epoca Unix: iat (emesso a), nbf (non prima) e exp (scade). Questo strumento li converte in date UTC per te.`)
};

const pt_br2_jw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elas são reivindicações de tempo padrão em segundos desde a Unix epoch: iat (emitido em), nbf (não antes), e exp (expira). Esta ferramenta as converte para datas UTC para você.`)
};

const pt_jw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`São reivindicações de tempo padrão em segundos desde o Unix epoch: iat (emitido em), nbf (não antes) e exp (expira). Esta ferramenta converte-as para datas UTC para si.`)
};

const ja_jw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`これらはUnix epochで秒数での標準的な時間クレームです：iat（発行時刻）、nbf（有効前）、exp（有効期限）。このツールはそれらをUTC日付に変換します。`)
};

const zh_jw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它们是以 Unix epoch 以来的秒数表示的标准时间声明：iat（签发时间）、nbf（生效时间）和 exp（过期时间）。此工具会为你将它们转换为 UTC 日期。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const jw_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.jw_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("jw_faq2_a", locale)
	if (locale === "en") return en_jw_faq2_a(inputs)
	if (locale === "es") return es_jw_faq2_a(inputs)
	if (locale === "de") return de_jw_faq2_a(inputs)
	if (locale === "nl") return nl_jw_faq2_a(inputs)
	if (locale === "fr") return fr_jw_faq2_a(inputs)
	if (locale === "it") return it_jw_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_jw_faq2_a(inputs)
	if (locale === "pt") return pt_jw_faq2_a(inputs)
	if (locale === "ja") return ja_jw_faq2_a(inputs)
	return zh_jw_faq2_a(inputs)
};